import { render, staticRenderFns } from "./cjlist.vue?vue&type=template&id=8f7e4b3c&scoped=true&"
import script from "./cjlist.vue?vue&type=script&lang=js&"
export * from "./cjlist.vue?vue&type=script&lang=js&"
import style0 from "./cjlist.vue?vue&type=style&index=0&id=8f7e4b3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f7e4b3c",
  null
  
)

export default component.exports